import { useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';

const WidgetListItem = (props) => {
  const {
    classes,
    createdAt,
    name,
    currencyType,
    overdueDays,
    onButtonClick,
    disableDivider,
    style,
    warningThreshold,
    overdueThreshold,
    ...rest
  } = props;

  const theme = useTheme()

  const [loading, setLoading] = React.useState(false);

  const isWarning = overdueDays >= warningThreshold && overdueDays < overdueThreshold;
  const showOverdue = overdueDays >= warningThreshold;

  return (
    <div
      style={{
        borderBottom: disableDivider ? 'none' : '1px solid #eee',
        padding: '8px 12px',
        background: 'transparent',
        ...style,
      }}
      {...rest}
    >
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        width: '100%'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
          <Typography
            style={{
              color: '#1F1F1F',
              fontSize: 12,
              fontWeight: 400,
              marginRight: 6,
              whiteSpace: 'nowrap',
            }}
          >
            {createdAt &&
              new Date(createdAt).toLocaleDateString('en-AU')}
          </Typography>
          <Typography style={{
            fontWeight: 500,
            fontSize: 12,
            color: '#1F1F1F',
          }}>
            ·
          </Typography >
          <Typography
            style={{
              fontWeight: 500,
              fontSize: 12,
              color: '#222',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              marginLeft: 6,
              maxWidth: 140,
            }}
          >
            {name}
          </Typography>
          {currencyType ? (<>
          <Typography style={{
            fontWeight: 500,
            marginLeft: 6,
            fontSize: 12,
            color: '#1F1F1F',
          }}>
            ·
          </Typography >
          <Typography
            style={{
              fontWeight: 500,
              fontSize: 12,
              color: '#222',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              marginLeft: 6,
              maxWidth: 140,
            }}
          >
            {currencyType}
          </Typography>
          </>
        ) : null}
        </div>
        <Button
          variant="text"
          size="small"
          style={{
            color: theme?.palette?.secondary?.main || '#53BCEB',
            fontWeight: 500,
            fontSize: 13,
            minWidth: 0,
            padding: 0,
          }}
          onClick={onButtonClick}
        >
          VIEW
        </Button>
      </div>
      {showOverdue && (
        <Typography
          style={{
            marginTop: 4,
            marginLeft: 0,
            fontWeight: 500,
            fontSize: 12,
            color: isWarning ? '#FFB300' : '#E53935',
          }}
        >
          Overdue {overdueDays} days
        </Typography>
      )}
    </div>
  );
}

WidgetListItem.propTypes = {
  classes: PropTypes.object.isRequired,
  createdAt: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  overdueDays: PropTypes.number,
  onButtonClick: PropTypes.func.isRequired,
  disableDivider: PropTypes.bool,
  style: PropTypes.object,
};

export default WidgetListItem;